import React from "react";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";

import { AppBar, Box, IconButton, Toolbar, Tooltip } from "@mui/material";
import Notification from "../../../components/Notification";
import LanguageSelector from "../../../components/LanguageSelector";
import { useThemeMode } from "../../../hooks/useContext/themeMode";

const Header = (props) => {
  const { mode, toggleThemeMode } = useThemeMode();
  const isDark = mode === "dark";

  return (
    <AppBar
      sx={{
        backgroundColor: (theme) => theme.palette.background.paper,
        color: "text.primary",
        borderBottom: "1px solid",
        borderColor: "divider",
        ...props.sx,
      }}
      elevation={0}
      className={props.customClass}
    >
      <Toolbar>
        <IconButton
          color="inherit"
          onClick={props.toggleMobileSidebar}
          sx={{
            display: {
              lg: "none",
              xs: "inline",
            },
          }}
        >
          <MenuOutlinedIcon width="20" height="20" />
        </IconButton>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
            width: "100%",
          }}
        >
          <LanguageSelector />
          <Tooltip
            title={isDark ? "Switch to light mode" : "Switch to dark mode"}
          >
            <IconButton color="inherit" onClick={toggleThemeMode}>
              {isDark ? <LightModeOutlinedIcon /> : <DarkModeOutlinedIcon />}
            </IconButton>
          </Tooltip>
          <Notification />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
